import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';

import MerchantRebate from 'core/modules/MerchantRebate/MerchantRebate';
import MerchantClickUrlLink from 'core/modules/MerchantClickUrlLink/MerchantClickUrlLink';

function MerchantPageTitle({
  merchant, merchants, config, isSuspended, keywords,
}) {
  const {
    name = 'Merchant', rebate, offers, message, isDirect,
  } = merchant;
  const { rebateOptions, showHeaderWithStoreCount, directMerchantName } = config;
  // Page title should not include the 'Shop and..' like rebate additional prefix
  // As this substring is already included in the header text
  const customizedRebateOptions = {
    ...rebateOptions,
    ...{
      prefix: 'earn',
      tiered: {
        rebateAdditionalPrefix: false,
      },
    },
  };

  // Suspended merchant
  if (isSuspended) {
    return <h2>{message || `${name} does not currently participate in the program.`}</h2>;
  }

  // Multiple merchants title
  if (!isEmpty(merchants)) {
    return showHeaderWithStoreCount
      ? <h2>We found {merchants.length} results for "{keywords}"</h2>
      : <h2>Showing results for "{keywords}"</h2>;
  }

  // Single metchant
  if (!isEmpty(merchant)) {
    const renderOfferText = (offers) => {
      if (isDirect) {
        return <h2>{directMerchantName} offer{offers.length > 1 ? 's' : ''} from {merchant.name}</h2>;
      }

      return <h2>Shop these offers available at {merchant.name}</h2>;
    };

    return offers.length || (isDirect && rebate)
      ? renderOfferText(offers)
      : (
        <MerchantClickUrlLink merchant={merchant}>
          <h2>Shop at {name} and <MerchantRebate {...rebate} {...customizedRebateOptions} /></h2>
        </MerchantClickUrlLink>
      );
  }

  // Return nothing by default
  return null;
}

MerchantPageTitle.propTypes = {
  merchant: PropTypes.shape({}),
  merchants: PropTypes.arrayOf(PropTypes.shape({})),
  config: PropTypes.shape({}),
  isSuspended: PropTypes.bool,
  keywords: PropTypes.string,
};

MerchantPageTitle.defaultProps = {
  config: {},
  merchant: {},
  merchants: [],
  isSuspended: false,
  keywords: '',
};

export default MerchantPageTitle;
